import { render, staticRenderFns } from "./LightBox.vue?vue&type=template&id=09ed5f4c&scoped=true"
import script from "./LightBox.vue?vue&type=script&lang=ts"
export * from "./LightBox.vue?vue&type=script&lang=ts"
import style0 from "./LightBox.vue?vue&type=style&index=0&id=09ed5f4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ed5f4c",
  null
  
)

export default component.exports